export enum UNIT {
  UNIT_KGCO = 'kg CO',
  UNIT_TCO = 'tCO',
  UNIT_KG = 'kg',
  UNIT_KM = 'km',
  UNIT_KWH = 'kWh',
  UNIT_EQ = 'eq',
  UNIT_PERCENT = '%',
}
